import 'fslightbox';
import tippy from 'tippy.js'
import {createApp} from '../../node_modules/vue/dist/vue.esm-bundler';

import Accordion from './modules/Accordion';
import NotificationBox from './modules/NotificationBox';
import Modal from './modules/Modal';
import stickAreaObserver from './modules/StickyAreaObserver';
import mobileNavigation from './modules/MobileNavigation';
import NfxSwiper from './modules/NfxSwiper';
import tabs from './modules/Tabs';

import ContactForm from './components/ContactForm.vue';
import Calculator from './components/Calculator.vue';

import Accessibility from './modules/Accessibility';

Accordion.init();
NotificationBox.init();
Modal.init();
stickAreaObserver.init();
mobileNavigation.init();
if (!document.querySelector('.editmode')) {
    const sliderContainerArr = document.querySelectorAll('.js-slider');
    sliderContainerArr.forEach((container) => {
        const slider = new NfxSwiper(container);
        slider.init()
    } );
}
tabs.init();

tippy('[data-tippy-content]', {
    interactive: true,
    theme: 'light',
    allowHTML: true,
});

const contactFormElement = document.querySelector('.vue-contact-form');
if (contactFormElement) {
    const contactFormApp = createApp({});
    contactFormApp.component('contact-form', ContactForm);
    contactFormApp.mount('.vue-contact-form');
}

const calculatorFormElmeent = document.querySelector('.vue-calculator');
if (calculatorFormElmeent) {
    const calculatorApp = createApp({});
    calculatorApp.component('calculator', Calculator);
    calculatorApp.mount('.vue-calculator');
}

const cookieSettingsLink = document.evaluate("//a[contains(text(), 'Cookie-Einstellungen')]", document, null, XPathResult.ANY_TYPE, null ).iterateNext();
if (cookieSettingsLink) {
    cookieSettingsLink.addEventListener('click', (event) => {
        event.preventDefault()
        UC_UI.showSecondLayer();
    });
}


const ariaLinks = document.querySelectorAll('.js-aria-link');
Accessibility.enableEnterKeyLinks(ariaLinks)

const ariaInteract = document.querySelectorAll('.js-aria-interact');
Accessibility.enableKeyboardClick(ariaInteract)
